import activationTranslations from "./activation"
import authTranslations from "./auth"
import generalTranslations from "./general"
import searchTranslations from "./search"
import channelsTranslations from "./channels"
import playerTranslations from "./player"
import commerceTranslations from "./commerce"
import eventsTranslations from "./events"
import tournamentsTranslations from "./tournaments"
import playlistsTranslations from "./playlists"
import calendarTranslations from "./calendar"
import redeemTranslations from "./redeem";
import myTeamTranslations from "./my-team";
import profileTranslations from "./profile"

const translations = {
  ...generalTranslations,
  ...activationTranslations,
  ...authTranslations,
  ...searchTranslations,
  ...channelsTranslations,
  ...playerTranslations,
  ...commerceTranslations,
  ...eventsTranslations,
  ...tournamentsTranslations,
  ...playlistsTranslations,
  ...calendarTranslations,
  ...redeemTranslations,
  ...myTeamTranslations,
  ...profileTranslations
};

export default translations
